import gql from 'graphql-tag';
import Client from './Client';
import Deceased from './Deceased';
import Member from './Member';
import CremationManagerAddressBook from './AddressBook';
import Quote from './Quote';
import AshLocation from './AshLocation';
import Appointment from './Appointment';
import DispatchDate from './DispatchDate';
import Pickup from './Pickup';

export default gql`
    fragment Enquiry on CMEnquiry {
        ID
        Created
        LegacyKey
        EnquiryByBusiness
        EnquiryType
        ClientSameAsEnquirer
        Notes
        CremationDate
        CremationTime
        SameDayCremation
        NextDayCremation
        RequestsCertificateOfContents
        PickupMethod
        Client {
            ...Client
        }
        Enquirer {
            ...Client
        }
        CreatedBy {
            ...Member
        }
        CremationOrder {
            ID
            LegacyKey
            CremationCancelled
        }
        PlaqueOrder {
            ID
            LegacyKey
            Cancelled
        }
        Deceased {
            ...Deceased
        }
        DispatchDates {
            ...DispatchDate
        }
        Business {
            ...CremationManagerAddressBook
        }
        PlaqueLocation {
            ...CremationManagerAddressBook
        }
        Quotes {
            ...Quote
        }
        Appointments {
            ...Appointment
        }
        AshLocations {
            ...AshLocation
        }
        Pickup {
            ...Pickup
        }
        LeadSource {
            ID
            SourceType
            SourceName
        }
    }
    ${Client}
    ${Deceased}
    ${DispatchDate}
    ${Member}
    ${CremationManagerAddressBook}
    ${AshLocation}
    ${Quote}
    ${Appointment}
    ${Pickup}
`;
